// extracted by mini-css-extract-plugin
export default {"banner":"TopbarPromoBanner_banner__dYv34","separator":"TopbarPromoBanner_separator__aJgsQ","cta":"TopbarPromoBanner_cta__tJAs2"};